/**
 * `shell/AppFooter.tsx` — the AppShell footer.
 *
 * Extracted from `AppShell.tsx` (behaviour-preserving). Privacy / Terms /
 * API-docs stub links + the "small team, working in the open" line.
 */
import { Link } from "react-router-dom";

export function AppFooter() {
  return (
    <footer className="border-t border-border/60 bg-bg-elevated/40">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-4 text-xs text-fg-subtle sm:px-6">
        <span>Tarii — we're a small team, working in the open.</span>
        <nav className="flex flex-wrap gap-3">
          <Link to="/privacy" className="hover:text-fg-muted">
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-fg-muted">
            Terms
          </Link>
          <a href="/api/docs" target="_blank" rel="noreferrer" className="hover:text-fg-muted">
            API docs
          </a>
        </nav>
      </div>
    </footer>
  );
}
